import React from 'react';
import type { Ctx } from '@reatom/framework';
import { createCtx } from '@reatom/framework';
import { setupBatch, useCtx, withBatching } from '@reatom/npm-react';
import { urlAtom, setupUrlAtomSettings } from '@reatom/url';
import { unstable_batchedUpdates } from 'react-dom';
import { useLocation } from 'react-router-dom';

import { createDevtools } from '@/js/libs/devtools';

setupBatch(unstable_batchedUpdates);
export const ctx: Ctx = withBatching(createCtx({ restrictMultipleContexts: false }));

setupUrlAtomSettings(ctx, () => new URL(window.location.href));

createDevtools(ctx);

export const RouterDevtoolsSync = React.memo(function RouterDevtoolsSync() {
  // subscribe to location changes
  useLocation();
  const reactCtx = useCtx();
  if (reactCtx.get(urlAtom).href !== window.location.href) {
    urlAtom(reactCtx, new URL(window.location.href));
  }

  // return <div />;
  return null;
});
